// extracted by mini-css-extract-plugin
var _1 = "oH2_A";
export { _1 as "base" }
